// extracted by mini-css-extract-plugin
export default {"backdrop":"dialog_backdrop__eqphD","dialog":"dialog_dialog__bVOyg","scrollable":"dialog_scrollable__cwOyx","opened":"dialog_opened__pxVUM","grounded":"dialog_grounded__y-vLY"};